<template>
    <div class="map-container animated zoomIn">
        <div id="map">
        </div>
        <img :src="fj" class="fj">
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import echarts from "echarts";
    import fj from "@/assets/images/fj.png";
    import '../../node_modules/echarts/map/js/province/fujian.js'

    export default {
        name: "i-map",
        components: {},
        data() {
            return {
                map: null,
                options: {},
                fj: fj
            }
        },
        methods: {
            selectCity: function () {
                this.$store.commit('componentsSwitch', {name: 'leftMenu', status: true});
                this.$store.commit('componentsSwitch', {name: 'intro', status: false});
                this.$store.commit('componentsSwitch', {name: 'recommend', status: false});
                this.$store.commit('changeLogoColor', "#000");
            },
            createMap: function () {
                this.map = echarts.init(document.querySelector("#map"));
                this.map.on('click', params => {
                    this.$store.commit("setCurrCity", params.name);
                    this.selectCity();
                    this.$store.commit('closeProject');
                    this.$store.commit('setShowContent', false);
                    this.options.geo.regions = [
                        {
                            name: params.name,
                            selected: true,
                        }
                    ];
                    this.map.setOption(this.options)
                });
                this.options = {
                    backgroundColor: 'transparent',
                    series: [{
                        type: 'scatter',
                        coordinateSystem: 'geo' // 对应上方配置
                    }
                    ],
                    geo: {
                        map: '福建',
                        roam: false,
                        label: {
                            show: true,
                            color: '#000',
                            offset: [15, 70],
                        },
                        itemStyle: { // 设置地图块的相关显示信息
                            areaColor: '#fff',
                            borderColor: '#eeeeee',
                            borderWidth: 2
                        },
                        emphasis: {
                            label: {
                                show: true,
                                color: '#fff',
                            },
                            itemStyle: {
                                areaColor: '#EF493D',
                                borderColor: '#eeeeee',
                                shadowColor: '#888',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2,
                                shadowBlur: 5,
                                borderWidth: 0
                            }
                        },
                        left: '15%',
                        right: '15%',
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}'
                    },
                    toolbox: {
                        show: false,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                            dataView: {readOnly: false},
                            restore: {},
                            saveAsImage: {}
                        },
                        iconStyle: {
                            normal: {
                                color: '#fff'
                            }
                        }
                    },
                };
                this.map.setOption(this.options);
            }
        },
        mounted: function () {
            this.createMap();
        },
        computed: {
            ...mapGetters([
                'component', 'changeLogoColor', 'projectOpened', 'currCity', 'media'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .map-container {
        width: 30vw;
        height: 55vh;
        position: absolute;
        right: 15vw;
        top: 100px;
    }
    #map{
        width: 30vw;
        height: 55vh;
        position: absolute;
        left: 0;
        top: 0;
    }
    .fj{
        position: absolute;
        width: 30px;
        right: 2vw;
        bottom:20px;
    }
</style>